var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.HtmbSh_edit),
      expression: "HtmbSh_edit"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("合同模板审核-详情")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "750px",
      "background-color": "white",
      "margin": "75px 40px 0 40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-left": "3%"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "40px"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "10px"
    }
  }, [_c('span', [_vm._v("员工合同模板名称")]), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "margin-left": "10px",
      "width": "200px"
    },
    model: {
      value: (_vm.ruleForm.template_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "template_name", $$v)
      },
      expression: "ruleForm.template_name"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("合同员工分类 ")]), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "margin-left": "10px",
      "width": "200px"
    },
    model: {
      value: (_vm.ruleForm.dictionaries_name),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "dictionaries_name", $$v)
      },
      expression: "ruleForm.dictionaries_name"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin-left": "20px"
    }
  }, [_c('span', [_vm._v("生效日期 ")]), _vm._v(" "), _c('el-date-picker', {
    staticStyle: {
      "width": "200px",
      "margin-left": "10px"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.ruleForm.template_date),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "template_date", $$v)
      },
      expression: "ruleForm.template_date"
    }
  })], 1)]), _vm._v(" "), [_c('div', {
    staticClass: "edit_container"
  }, [_c('quill-editor', {
    ref: "myQuillEditor",
    staticClass: "w",
    staticStyle: {
      "margin-top": "20px"
    },
    attrs: {
      "options": _vm.editorOption
    },
    on: {
      "blur": function($event) {
        return _vm.onEditorBlur($event)
      },
      "focus": function($event) {
        return _vm.onEditorFocus($event)
      },
      "change": function($event) {
        return _vm.onEditorChange($event)
      }
    },
    model: {
      value: (_vm.ruleForm.template_content),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "template_content", $$v)
      },
      expression: "ruleForm.template_content"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ql-editor",
    domProps: {
      "innerHTML": _vm._s(_vm.str)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.str) + "\n          ")])], 1)]], 2)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a17666a","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ygdagl/HtmbGl/HtmbGl_xq.vue
// module id = null
// module chunks = 